import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/CustomButton";
import CustomSelect from "../../../components/customSelect/CustomSelect";
import { useDisclosure } from "@mantine/hooks";
import AsyncSelect from "react-select/async";
import CheckEligibilityModal from "./checkEligibility/modal/EligibilityModal";
import { ReactComponent as ModalIcon } from "../../../assets/modalLogo.svg";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import base_url from "../../../api/bootapi";
import { Modal } from "@mantine/core";
import { ReactComponent as CloseIcon } from "../../../assets/iconamoon_close.svg";
import { ReactComponent as HandIcon } from "../../../assets/Hand Money.svg";
import { ReactComponent as StarLine } from "../../../assets/star-line.svg";
import { CircularProgress } from "@mui/material";
import { ReactComponent as FailedIcon } from "../../../assets/failed-eligibility.svg";
import { ReactComponent as HeadSetIcon } from "../../../assets/fi-rr-headset.svg";
import { ReactComponent as DocumentIcon } from "../../../assets/fi-rr-document.svg";
import { useNavigate } from "react-router-dom";

const CompensationCalculator = () => {
  const data = [
    { value: "delayed", label: "My flight was delayed" },
    { value: "cancelled", label: "My flight was canceled" },
    {
      value: "denied_boarding",
      label: "I was denied boarding due to overbooking",
    },
    {
      value: "lost/damaged",
      label: "My baggage was lost, delayed, or damaged",
    },
    { value: "other", label: "Other issue" },
  ];

  const [openEligibility, setOpenEligibility] = useState(false);
  const [selectedDeparture, setSelectedDeparture] = useState(null);
  const [selectedArrival, setSelectedArrival] = useState(null);
  const [claimReason, setClaimReason] = useState(null);
  const [isCheckCompensation, setIsCheckCompensation] = useState(true);

  const [loading, setLoading] = useState(false);

  const [eligibleData, setEligibleData] = useState(null);

  const navigate = useNavigate();

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  useEffect(() => {
    setEligibleData(null);
    if (selectedArrival && selectedDeparture && claimReason) {
      setIsCheckCompensation(false);
    } else {
      setIsCheckCompensation(true);
    }
  }, [selectedDeparture, selectedArrival, claimReason]);

  useEffect(() => {
    const savedData = localStorage.getItem("flightDetailsData");
    const savedClaimType = localStorage.getItem("claimType"); // This is now a string

    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        if (parsedData.departureAirport) {
          setValue("departureAirport", parsedData.departureAirport);
          setSelectedDeparture(parsedData.departureAirport);
        }
        if (parsedData.arrivalAirport) {
          setValue("arrivalAirport", parsedData.arrivalAirport);
          setSelectedArrival(parsedData.arrivalAirport);
        }
      } catch (e) {
        console.error("Error parsing flight details:", e);
      }
    }

    if (savedClaimType) {
      // Find the matching claim option
      const matchedClaim = data.find((item) => item.value === savedClaimType);
      if (matchedClaim) {
        setValue("claimReason", matchedClaim);
        setClaimReason(matchedClaim);
      }
    }
  }, [setValue]);

  // Update localStorage when any selection changes
  useEffect(() => {
    const departure = watch("departureAirport");
    const arrival = watch("arrivalAirport");
    const claim = watch("claimReason");

    if (departure || arrival) {
      const flightData = localStorage.getItem("flightDetailsData") || "{}";
      try {
        const parsedFlightData = JSON.parse(flightData);
        localStorage.setItem(
          "flightDetailsData",
          JSON.stringify({
            ...parsedFlightData,
            departureAirport: departure || parsedFlightData.departureAirport,
            arrivalAirport: arrival || parsedFlightData.arrivalAirport,
          })
        );
      } catch (e) {
        console.error("Error updating flight details:", e);
      }
    }

    if (claim) {
      // Store just the value string
      localStorage.setItem("claimType", claim.value);
    }
  }, [
    watch("departureAirport"),
    watch("arrivalAirport"),
    watch("claimReason"),
  ]);

  const loadAirportsOptions = async (inputValue) => {
    const airports = await fetchAllAirportslist(inputValue);
    return airports;
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "250px",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000", // Ensure selected option is visible
    }),
  };

  const onCheckCompensation = async () => {
    setEligibleData(null);
    setLoading(true);
    try {
      const payload = {
        departed_from: selectedDeparture.value,
        arrival_airport: selectedArrival.value,
        claim_type: claimReason.value,
      };

      const response = await axios.post(
        base_url.api1 + "/tourapp/cal-eligibility",
        payload
      );

      setLoading(false);
      setEligibleData(response?.data);

      console.log("Response:==========================> ", response.data);
    } catch (error) {
      console.error("Error:============================>", error);

      if (error?.response.status === 400) {
        setEligibleData(error.response.data);
      } else {
        setEligibleData(null);
      }

      setLoading(false);
    }
  };

  const fetchAllAirportslist = async (searchTerm = "") => {
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`,
        {
          params: {
            search: searchTerm, // Pass searchTerm as a query parameter
          },
        }
      );

      // Process the response data
      const processedAirports = response.data.Airports.map((airport) => ({
        label: `${airport.airport_name.replace(
          /[\n\u0000-\u001F\u007F-\u009F]/g,
          ""
        )} (${airport.iata_code})`,
        value: airport.iata_code,
      }));

      return processedAirports;
    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };
  // console.log(claimReason);

  return (
    <div
      className="container-wrapper compensation-calculator-wrapper"
      style={{ position: "relative" }}
    >
      {eligibleData && (
        <span className="star-line">
          <StarLine />
        </span>
      )}

      <div className="header-text-wrapper">
        <h1 className="header text-center">
          How much compensation are you entitled to?
        </h1>
        <p className="sub-header text-center">
          The amount of compensation you can receive depends on the type of
          disruption and the flight distance. Compensation typically ranges from
          €250 to €600 (Approx. $270–$700), depending on the distance of your
          flight.
        </p>
      </div>

      <div className="calculator-wrapper">
        <div className="flex-between">
          <h2 className="mid-header">Compensation calculator</h2>
          <CustomButton
            onClick={onCheckCompensation}
            btnText={"calculate my compensation"}
            disabled={isCheckCompensation}
          />
        </div>

        <div
          className="select-wrapper"
          style={{
            display: "flex",
            marginTop: "30px",
            justifyContent: "space-between",
            zIndex: 99,
          }}
        >
          <div className="custom-select" style={{ width: "30%", gap: "0" }}>
            <span className="select-label">
              Claim reason<span style={{ color: "#de8385" }}> *</span>
            </span>
            <div
              className="select-box"
              style={{
                backgroundColor: "#FAFDFF",
                marginTop: "12px",
              }}
            >
              <Controller
                name="claimReason"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions={data}
                    placeholder="Select form"
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setClaimReason(selectedOption);
                    }}
                    styles={selectStyles}
                  />
                )}
              />
            </div>
            {errors.claimReason && (
              <p className="errormessage">{errors.claimReason.message}</p>
            )}
          </div>

          <div className="custom-select" style={{ width: "30%", gap: "0" }}>
            <span className="select-label">
              Flight from<span style={{ color: "#de8385" }}> *</span>
            </span>
            <div
              className="select-box"
              style={{
                backgroundColor: "#FAFDFF",
                marginTop: "12px",
              }}
            >
              <Controller
                name="departureAirport"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadAirportsOptions}
                    placeholder="Flight from"
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setSelectedDeparture(selectedOption);
                    }}
                    styles={selectStyles}
                  />
                )}
              />
            </div>
            {errors.departureAirport && (
              <p className="errormessage">{errors.departureAirport.message}</p>
            )}
          </div>

          <div className="custom-select" style={{ width: "30%", gap: "0" }}>
            <span className="select-label">
              Flight to<span style={{ color: "#de8385" }}> *</span>
            </span>
            <div
              className="select-box"
              style={{
                backgroundColor: "#FAFDFF",
                marginTop: "12px",
              }}
            >
              <Controller
                name="arrivalAirport"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadAirportsOptions}
                    placeholder="Flight to"
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setSelectedArrival(selectedOption);
                    }}
                    styles={selectStyles}
                  />
                )}
              />
            </div>
            {errors.arrivalAirport && (
              <p style={{}} className="errormessage">
                {errors.arrivalAirport.message}
              </p>
            )}
          </div>
        </div>

        <div className="mobile-calculate-btn">
          <CustomButton
            onClick={onCheckCompensation}
            btnText={"calculate my compensation"}
          />
        </div>
        {loading && (
          <div
            style={{
              height: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        )}

        {eligibleData && eligibleData?.eligible && (
          <div className="compensation-calculate-result-wrapper">
            <span className="hand-icon">
              <HandIcon />
            </span>

            <div className="result-wrapper">
              <h1 className="result-text">
                You could be entitled to up to{" "}
                {eligibleData?.currency === "EUR" ? "€" : "$"}
                {eligibleData?.compensation_amount_per_passenger} in
                compensation per passenger
              </h1>

              <h6 className="result-sub-text">
                The amount of compensation you can receive depends on the type
                of disruption and the flight distance. Under regulations like
                {" " + eligibleData?.regulation}, passengers may be entitled to
                the following amounts
              </h6>

              <CustomButton
                btnText={"proceed to claim"}
                onClick={() => {
                  navigate("/file-claim");
                }}
              />
            </div>
          </div>
        )}
        {eligibleData && !eligibleData?.eligible && (
          <div className="compensation-calculate-result-wrapper">
            <span className="hand-icon">
              <FailedIcon />
            </span>
            {/* <span className="star-line">
<StarLine />
</span> */}
            <div className="result-wrapper">
              <h1 className="result-text" style={{ color: "#D04244" }}>
                We're sorry...
              </h1>

              <h6 className="result-sub-text">
                Unfortunately, based on current regulations, your case does not
                qualify for compensation.
              </h6>

              <div className="support-wrapper">
                <div className="customer-support-wrapper sub-text">
                  <span onClick={() => navigate("/contact-us")}>
                    <HeadSetIcon />
                    Contact our support team
                  </span>
                </div>
                <div className="customer-support-wrapper sub-text">
                  <span onClick={() => navigate("/disclaimer")}>
                    <DocumentIcon />
                    Read more about your rights
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <CheckEligibilityModal
        open={openEligibility}
        close={setOpenEligibility}
        selectedDeparture={selectedDeparture}
        selectedArrival={selectedArrival}
        claimReason={claimReason}
        setSelectedDeparture={setSelectedDeparture}
        setSelectedArrival={setSelectedArrival}
      />
    </div>
  );
};

export default CompensationCalculator;
